<template>
  <naj-box
    :title="title"
    class="add-new-person"
  >
    <slot />
    <v-row>
      <!-- TODO: this is an example to use naj-social-identity-input inasted of socialType & socialId inputs -->
      <v-col
        v-if="false"
        cols="12"
        lg="6"
      >
        <naj-social-identity-input
          :social-types="filteredSocialTypes"
          :type-id-value.sync="formModel[`socialIdType${formattedSuggestedTechnicalName}`]"
          :type-disabled="isChecking || isRetrievedFromMci || viewMode"
          :type-validates="`${!isFirmManager || required ? 'required' : ''}`"
          :social-id-disabled="isChecking || !formModel[`socialIdType${formattedSuggestedTechnicalName}`] || isRetrievedFromMci || viewMode"
          :social-id-visible="formModel[`socialIdType${formattedSuggestedTechnicalName}`] != socialIdentityTypeEnum.without"
          :social-id-value.sync="formModel[`socialId${formattedSuggestedTechnicalName}`]"
          :social-id-validates="socialIdRules"
          :social-id-msak="socialIdMask"
          @typeChanged="socialIdTypeChanged"
          @socialIdInput="socialChanged"
        ></naj-social-identity-input>
      </v-col>
      <v-col
        v-if="showPartyRole && partyRoles && partyRoles.length > 0"
        cols="12"
        sm="6"
        md="4"
        lg
      >
        <party-role
          :form-model="formModel"
          :options="partyRoles"
          :existing-parties="existingParties"
          :label="local.partyTypeSelection.reference"
          :required="required"
          :cols="12"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.personInformation.socialType"
          :technical-name="`socialIdType${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`socialIdType${formattedSuggestedTechnicalName}`]"
          :items="filteredSocialTypes"
          item-text="name"
          item-value="id"
          :disabled="isChecking || isRetrievedFromMci || viewMode"
          :validates="`${!isFirmManager || required ? 'required' : ''}`"
          @change="socialIdTypeChanged"
        ></naj-input>
      </v-col>

      <v-col
        v-if="formModel[`socialIdType${formattedSuggestedTechnicalName}`] != socialIdentityTypeEnum.without"
        cols="12"
        sm="6"
        md="4"
        lg
      >
        <naj-input
          v-mask="socialIdMask"
          :type-id="formFieldType.text"
          :label="local.personInformation.social"
          :technical-name="`socialId${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`socialId${formattedSuggestedTechnicalName}`]"
          :disabled="isChecking || !formModel[`socialIdType${formattedSuggestedTechnicalName}`] || isRetrievedFromMci || viewMode"
          :validates="socialIdRules"
          @input="socialChanged"
        ></naj-input>
      </v-col>

      <v-col
        v-if="!isFirmManager"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.personInformation.dateOfBirth"
          :technical-name="`dateOfBirth${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`dateOfBirth${formattedSuggestedTechnicalName}`]"
          :disabled="isChecking || !formModel[`socialId${formattedSuggestedTechnicalName}`] || viewMode"
          :validates="`${required ? 'required' : ''}`"
          @change="dateOfBirthChanged"
        ></naj-input>
      </v-col>
      <v-col
        v-if="showVerificationCode && !hasSocialIdAndDateOfBirth && ((isRequiresChecking && !isRetrieved) || isChecking)"
        cols="12"
        sm="6"
        md="4"
        lg="3"
        class="d-flex align-start verification-code-container"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.verificationCode"
          :technical-name="`verificationCode${formattedSuggestedTechnicalName}`"
          :value.sync="verificationCodeModel"
          :disabled="isChecking || viewMode"
          :validates="`required|verification_code:${verificationCode}`"
        ></naj-input>
        <img
          class="verification-code-box"
          :src="verificationCodeImage"
          alt=""
          draggable="false"
        >
      </v-col>
      <v-col
        v-if="(isRequiresChecking && !isRetrieved) || isChecking"
        cols="12"
        sm="6"
        md="4"
        lg
        class="d-flex align-center check-container"
      >
        <naj-button
          square
          inputs-alignment
          :loading="isChecking"
          :disabled="checkButtonIsDisabled "
          @click="check"
        >
          {{ local.personInformation.check }}
        </naj-button>
        <naj-error-text
          :text="noticeText"
          size="medium"
          no-margin
        ></naj-error-text>
      </v-col>
    </v-row>

    <v-row v-if="formModel[`socialIdType${formattedSuggestedTechnicalName}`] == socialIdentityTypeEnum.passport">
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.date"
          :label="local.personInformation.passportDate"
          :technical-name="`passportDate${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`passportDate${formattedSuggestedTechnicalName}`]"
          :disabled="isChecking || !formModel[`socialId${formattedSuggestedTechnicalName}`] || viewMode"
          :validates="`${required ? 'required' : ''}`"
          :min-date="formModel[`dateOfBirth${formattedSuggestedTechnicalName}`] ? new Date(formModel[`dateOfBirth${formattedSuggestedTechnicalName}`]) : null"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="2"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.passportSource"
          :technical-name="`passportSource${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`passportSource${formattedSuggestedTechnicalName}`]"
          :disabled="isChecking || !formModel[`socialId${formattedSuggestedTechnicalName}`] || viewMode"
          :validates="`${required ? 'required' : ''}`"
        ></naj-input>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.firstName"
          :technical-name="`firstName${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`firstName${formattedSuggestedTechnicalName}`]"
          :disabled="
            (isRequiresChecking && required) ||
              isChecking ||
              isRetrieved ||
              viewMode
          "
          :validates="`${
            !isRetrieved
              ? (!isFirmManager || required ? 'required|' : '') + 'single_language_field|consistent_name_language:' + [formModel[`fatherName${formattedSuggestedTechnicalName}`], formModel[`grandFatherName${formattedSuggestedTechnicalName}`], formModel[`familyName${formattedSuggestedTechnicalName}`]].join('~~~')
              : ''
          }`"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="2"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.fatherName"
          :technical-name="`fatherName${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`fatherName${formattedSuggestedTechnicalName}`]"
          :disabled="
            (isRequiresChecking && required) ||
              isChecking ||
              isRetrieved ||
              viewMode
          "
          :validates="`${
            !isRetrieved
              ? (!isFirmManager || required ? 'required|' : '') + 'single_language_field|consistent_name_language:' + [formModel[`firstName${formattedSuggestedTechnicalName}`], formModel[`grandFatherName${formattedSuggestedTechnicalName}`], formModel[`familyName${formattedSuggestedTechnicalName}`]].join('~~~')
              : ''
          }`"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="2"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.grandFatherName"
          :technical-name="`grandFatherName${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`grandFatherName${formattedSuggestedTechnicalName}`]"
          :disabled="
            (isRequiresChecking && required) ||
              isChecking ||
              isRetrieved ||
              viewMode
          "
          :validates="`${
            !isRetrieved
              ? ((!isFirmManager || required ) && !hasPassport ? 'required|' : '') + 'single_language_field|consistent_name_language:' + [formModel[`firstName${formattedSuggestedTechnicalName}`], formModel[`fatherName${formattedSuggestedTechnicalName}`], formModel[`familyName${formattedSuggestedTechnicalName}`]].join('~~~')
              : ''
          }`"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.personInformation.familyName"
          :technical-name="`familyName${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`familyName${formattedSuggestedTechnicalName}`]"
          :disabled="
            (isRequiresChecking && required) ||
              isChecking ||
              isRetrieved ||
              viewMode
          "
          :validates="`${
            !isRetrieved
              ? (!isFirmManager || required ? 'required|' : '') + 'single_language_field|consistent_name_language:' + [formModel[`firstName${formattedSuggestedTechnicalName}`], formModel[`fatherName${formattedSuggestedTechnicalName}`], formModel[`grandFatherName${formattedSuggestedTechnicalName}`]].join('~~~')
              : ''
          }`"
        ></naj-input>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.personInformation.nationality"
          :technical-name="`nationalityCountryId${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`nationalityCountryId${formattedSuggestedTechnicalName}`]"
          :items="selectedCountries"
          item-text="name"
          item-value="id"
          :disabled="
            (isRequiresChecking && required) ||
              isChecking ||
              (isRetrieved && Boolean(formModel[`nationalityCountryId${formattedSuggestedTechnicalName}`])) ||
              !formModel[`socialIdType${formattedSuggestedTechnicalName}`] ||
              isSaudi ||
              viewMode
          "
          :validates="`${!isFirmManager || required ? 'required' : ''}`"
        ></naj-input>
      </v-col>
      <v-col
        v-if="!isFirmManager"
        cols="12"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.personInformation.sex"
          :technical-name="`sex${formattedSuggestedTechnicalName}`"
          :value.sync="formModel[`sex${formattedSuggestedTechnicalName}`]"
          :value-name.sync="formModel[`sexName${formattedSuggestedTechnicalName}`]"
          :items="sex"
          item-text="name"
          :disabled="viewMode"
          item-value="id"
          :validates="`${required ? 'required' : ''}`"
        ></naj-input>
      </v-col>

      <slot name="mobile" />
    </v-row>

    <prisoner-form
      v-if="false && showPrisonerForm"
      :form-model="formModel"
      :required="required"
      :show-prisoner-form="showPrisonerForm"
      :suggested-technical-name="formattedSuggestedTechnicalName"
      :is-disabled="
        (isRequiresChecking && required) ||
          isChecking ||
          isRetrieved ||
          viewMode
      "
    ></prisoner-form>
    <v-row v-if="showNeedsTranslatorForm">
      <v-col cols="12">
        <div class="translation-section">
          <naj-input
            :type-id="formFieldType.checkbox"
            :label="local.personInformation.needsTranslator"
            :technical-name="`needsTranslator${formattedSuggestedTechnicalName}`"
            :value.sync="formModel[`needsTranslator${formattedSuggestedTechnicalName}`]"
            :disabled="viewMode"
            @change="needToTranslateChangeHandler"
          ></naj-input>
        </div>
      </v-col>

      <v-col
        v-if="formModel[`needsTranslator${formattedSuggestedTechnicalName}`]"
        cols="12"
      >
        <v-row>
          <v-col
            cols="12"
            lg="6"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="local.personInformation.chooseTranslationLanguage"
              :technical-name="`mainLanguageId${formattedSuggestedTechnicalName}`"
              :value.sync="formModel[`mainLanguageId${formattedSuggestedTechnicalName}`]"
              :items="mainLanguages"
              item-text="name"
              item-value="id"
              validates="required"
              :disabled="viewMode"
              @change="mainLanguageChanged"
            ></naj-input>
          </v-col>

          <v-col
            v-if="formModel[`mainLanguageId${formattedSuggestedTechnicalName}`]"
            cols="12"
            lg="6"
          >
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="local.personInformation.chooseSubTranslationLanguage"
              :technical-name="`languageId${formattedSuggestedTechnicalName}`"
              :value.sync="formModel[`languageId${formattedSuggestedTechnicalName}`]"
              :items="subLanguages"
              item-text="name"
              item-value="id"
              validates="required"
              :disabled="viewMode"
              @change="subLanguageChanged"
            ></naj-input>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { countriesEnum, socialIdentityTypeEnum } from '@/helpers/enum';
import PrisonerForm from './prisoner-form';
import { createNamespacedHelpers } from 'vuex';
import PartyRole from '../../sub-party-role-selector/party-role.vue';
import {
  isSaudi,
  isType,
  getRelatedCasePartyByRelatedObjectKey,
  isDefendant,
} from '@/modules/lawsuit/helpers/utils';

const { mapActions: mapSysActions } = createNamespacedHelpers('SystemModule');
const { mapGetters } = createNamespacedHelpers('LawsuitModule');
const {
  mapState: mapLUTState,
  mapGetters: mapLUTGetters,
  mapActions: mapLUTActions,
} = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  inject: ['$validator'],
  components: { PrisonerForm, PartyRole },
  props: [
    'title',
    'viewMode',
    'formModel',
    'required',
    'showPrisonerForm',
    'isFirmManager',
    'showNeedsTranslatorForm',
    'filterNationalRegularResidencySocialId',
    'alwaysAllowChecking',
    'allowAddressCheck',
    'suggestedTechnicalName',
    'showPartyRole', // اظهار صفة الطرف
    'partyRoles', // array coming from ancestor
    'existingParties',
  ],
  data() {
    return {
      countriesEnum,
      socialIdentityTypeEnum,
      isChecking: false,
      requestError: null,
      firstBirthDateChangeOccurred: false,
      subLanguages: [],
      showVerificationCode: false,
      captchaId: null,
      verificationCode: '',
      verificationCodeInput: null,
      verificationCodeImage: '',
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    ...mapLUTState(['socialTypes', 'countries', 'sex', 'mainLanguages', 'mainSubLanguageDetails']),
    ...mapLUTGetters(['countriesForNonSaudi']),
    ...mapGetters(['isEditMode', 'isViewMode']),
    nationalityCountryId() {
      return this.formModel[`nationalityCountryId${this.formattedSuggestedTechnicalName}`];
    },
    formattedSuggestedTechnicalName() {
      return this.suggestedTechnicalName ? this.suggestedTechnicalName.charAt(0)
        .toUpperCase() + this.suggestedTechnicalName.slice(1) : '';
    },
    hasPassport() {
      return this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`] == socialIdentityTypeEnum.passport;
    },
    isSaudi() {
      return isSaudi(this.formModel, `socialIdType${this.formattedSuggestedTechnicalName}`);
    },
    filteredSocialTypes() {
      if (this.filterNationalRegularResidencySocialId) {
        const nationalRegularResidency = {
          [socialIdentityTypeEnum.nationalId]: true,
          [socialIdentityTypeEnum.regularResidency]: true,
        };
        return (this.socialTypes || []).filter(
          st => nationalRegularResidency[st.id]
        );
      }
      const relatedCaseParty = getRelatedCasePartyByRelatedObjectKey(
        this.formModel,
        this.formModel.casePartyObjectKey
      );
      if (!relatedCaseParty) return this.socialTypes;
      if (isType(relatedCaseParty.relatedPartyType, 'government')) {
        const saudiSocialTypes = {
          [socialIdentityTypeEnum.nationalId]: true,
          [socialIdentityTypeEnum.nationalIdBooklet]: true,
        };
        return (this.socialTypes || []).filter(st => saudiSocialTypes[st.id]);
      }
      return this.socialTypes;
    },
    selectedCountries() {
      return this.isSaudi ? this.countries : this.countriesForNonSaudi;
    },
    isRetrievedFromMci() {
      return Boolean(this.isFirmManager) && Boolean(this.formModel[`isRetrievedFromMci${this.formattedSuggestedTechnicalName}`]);
    },
    isRetrieved() {
      return Boolean(this.formModel[`isRetrievedFromMoi${this.formattedSuggestedTechnicalName}`]) || Boolean(this.isRetrievedFromMci) ||
        Boolean(this.formModel[`isRetrievedFromPrisons${this.formattedSuggestedTechnicalName}`]);
    },
    isRequiresChecking() {
      return !this.isFirmManager && this.isNationalRegularResidencySocialId;
    },
    isNationalRegularResidencySocialId() {
      const requireChecking = [
        socialIdentityTypeEnum.nationalId,
        socialIdentityTypeEnum.regularResidency,
      ];
      return requireChecking.indexOf(this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`]) !== -1;
    },
    isCheckSocialIdDependenciesExist() {
      return (
        (Boolean(this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`]) &&
          Boolean(this.formModel[`socialId${this.formattedSuggestedTechnicalName}`]) &&
          Boolean(this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`])) ||
        (Boolean(this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`]) &&
          Boolean(this.formModel[`socialId${this.formattedSuggestedTechnicalName}`]) &&
          Boolean(this.formModel[`firstName${this.formattedSuggestedTechnicalName}`])
        )
      );
    }, 
     hasSocialIdAndDateOfBirth() {
      return Boolean(this.formModel[`socialId${this.formattedSuggestedTechnicalName}`])
        && Boolean(this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`]);
    },
    socialIdRules() {
      return `${!this.isFirmManager || this.required ? 'required|' : ''}${this.isFirmManager ? '' : 'isIdAllowed'
        }${'|socialId:' + this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`]}${this.isCheckSocialIdDependenciesExist
          ? '|isVerified:' + (this.isRetrieved || !this.isRequiresChecking || (!this.required && !this.alwaysAllowChecking))
          : ''
        }`;
    },
    socialIdMask() {
      return this.isNationalRegularResidencySocialId
        ? `${this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`]}#########`
        : null;
    },
    noticeText() {
      if (isDefendant(this.formModel)) {
        if (this.userInfo.socialId.startsWith('1')) {
          return this.local.personInformation.nationalIdDefendantNoticeText;
        } else {
          return this.local.personInformation.regularResidencyDefendantNoticeText;
        }
      } else {
        return this.alwaysAllowChecking ? this.local.personInformation.regularResidencyNoticeText : this.local.personInformation.regularResidencyProsecutorNoticeText;
      }
    },
    verificationCodeModel: {
      get() {
        return this.verificationCodeInput;
      },
      set(value) {
        this.verificationCodeInput = value ? value.toUpperCase() : value;
      },
    },
    checkButtonIsDisabled() {
      if (this.isChecking || this.viewMode) {
        return true;
      }
      if (this.hasSocialIdAndDateOfBirth) {
        return false;
      }
      if (this.showVerificationCode && this.verificationCodeInput !== this.verificationCode) {
        return true;
      }
      if (isDefendant(this.formModel) || this.alwaysAllowChecking) {
        if (!this.userInfo.socialId.startsWith('1')) {
          return (!this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`] || !this.formModel[`socialId${this.formattedSuggestedTechnicalName}`]) && (!this.formModel[`socialId${this.formattedSuggestedTechnicalName}`] || !this.formModel[`firstName${this.formattedSuggestedTechnicalName}`]);
        }
        if (!this.formModel[`socialId${this.formattedSuggestedTechnicalName}`]) {
          return true;
        }
        if (!this.formModel[`firstName${this.formattedSuggestedTechnicalName}`] && !this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`]) {
          return true;
        }
        return false;
      }
      else {
        return !this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`] || !this.formModel[`socialId${this.formattedSuggestedTechnicalName}`];
      }
    },
    // removed nameGroupValues
  },
  watch: {
    nationalityCountryId(val) {
      val && this.setNationalityCountryName();
    },
  },
  mounted() {
    this.getUserInfo();
    this.firstBirthDateChangeOccurred = true;
    this.getMainLanguages().then(() => {
      this.restoreLanguageSelections();
    });
  },
  created() {
    this.getSocialTypes();
    this.getCountries();
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    ...mapLUTActions([
      'getSocialTypes',
      'getCountries',
      'getMainLanguages',
      'getSubLanguages',
      'getMainSubLanguageDetailsById',
    ]),
    ...mapSysActions([
      'checkMOIPersonalInfo',
      'validateLawyer',
      'getPrisonerCriminalRecord',
    ]),
    check() {
      if (!this.formModel[`socialId${this.formattedSuggestedTechnicalName}`]) {
        this.$Notice.error({
          title: this.local.personInformation.socialIdIsRequired,
          top: 50,
          duration: 5,
        });
        return;
      }
      if (!this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`] && !this.formModel[`firstName${this.formattedSuggestedTechnicalName}`]) {
        this.$Notice.error({
          title: this.local.personInformation.dateOfBirthIsRequired,
          top: 50,
          duration: 5,
        });
        return;
      }
      // eslint-disable-next-line eqeqeq
      if (
        this.isRequiresChecking &&
        this.formModel[`socialId${this.formattedSuggestedTechnicalName}`][0] != this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`]
      ) {
        this.$Notice.error({
          title: this.local.personInformation.socialIdTypeInValid,
          top: 50,
          duration: 5,
        });
        return;
      }
      const isDefendantAndNationalIdOrRegularResidency =
        (this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`] == this.socialIdentityTypeEnum.nationalId || this.formModel[`socialIdType${this.formattedSuggestedTechnicalName}`] == this.socialIdentityTypeEnum.regularResidency) &&
        isDefendant(this.formModel);


        const shouldBypassCaptcha = this.hasSocialIdAndDateOfBirth;
      if (shouldBypassCaptcha) {
        this.applyCaptcha({ isCaptchaRequired: false });
      }



      const personalInfoRequest = {
        socialId: this.formModel[`socialId${this.formattedSuggestedTechnicalName}`],
        dateOfBirth: this.formModel[`dateOfBirth${this.formattedSuggestedTechnicalName}`],
        firstName: isDefendantAndNationalIdOrRegularResidency || this.alwaysAllowChecking ? this.formModel[`firstName${this.formattedSuggestedTechnicalName}`] : null,
        allowAddressCheck: !!this.allowAddressCheck,
        captchaToken: !shouldBypassCaptcha && this.showVerificationCode && this.captchaId ? `${this.captchaId}:${this.verificationCodeInput}` : null,
        };
      this.isChecking = true;
      this.resetPersonalInfo();
      this.checkMOIPersonalInfo(personalInfoRequest)
        .then((personalInfo) => {
          debugger;
          const info = { ...personalInfo };
          const captcha = {
            isCaptchaRequired: info.isCaptchaRequired,
            captchaId: info.captchaId,
            captchaCode: info.captchaCode,
          };
          delete info.isCaptchaRequired;
          delete info.captchaId;
          delete info.captchaCode;
          this.applyCaptcha(shouldBypassCaptcha ? { isCaptchaRequired: false } : captcha);
          if (!shouldBypassCaptcha && captcha.isCaptchaRequired && !info.firstName) {
            this.$set(this.formModel, `isRetrievedFromMoi${this.formattedSuggestedTechnicalName}`, false);
            return;
          }
          this.toaster.success(this.local.common.verificationSucceeded, 2);
          for (const key in info) {
            if (Object.prototype.hasOwnProperty.call(info, key)) {
              this.$set(this.formModel, `${key}${this.formattedSuggestedTechnicalName}`, info[key]);
            }
          }
        })
        .catch((error) => {
          debugger;
          const errorBody = (error && error.response && error.response.data) || {};
          this.applyCaptcha(shouldBypassCaptcha ? { isCaptchaRequired: false } : (errorBody.data || errorBody));
    
          // avoid a duplicate toaster: the axios response interceptor already
          // shows the backend error message (e.g. service blocked) when handled.
          !error.handled && this.toaster.error(
            this.local.personInformation.checkPersonalInfoError
          );
          this.$set(this.formModel, `isRetrievedFromMoi${this.formattedSuggestedTechnicalName}`, false);
        })
        .finally(() => {
          debugger;
          this.isChecking = false;
        });

      this.getPrisonerCriminalRecord(personalInfoRequest)
        .then((prisonerInfo) => {
          for (const key in prisonerInfo) {
            if (Object.prototype.hasOwnProperty.call(prisonerInfo, key)) {
              this.$set(this.formModel, `${key}${this.formattedSuggestedTechnicalName}`, prisonerInfo[key]);
            }
          }
        })
        .catch(() => {
          this.$set(this.formModel, `isRetrievedFromPrisons${this.formattedSuggestedTechnicalName}`, false);
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    applyCaptcha(data) {
      const isCaptchaRequired = !!(data && data.isCaptchaRequired);
      const code = isCaptchaRequired ? (data.captchaCode || '').toUpperCase() : '';
      this.showVerificationCode = isCaptchaRequired;
      this.captchaId = isCaptchaRequired ? data.captchaId : null;
      this.verificationCode = code;
      this.verificationCodeInput = null;
      this.verificationCodeImage = code ? this.drawVerificationCode(code) : '';
    },
    drawVerificationCode(code) {
      const width = 160;
      const height = 50;
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return '';
      const random = (min, max) => min + Math.random() * (max - min);

      ctx.fillStyle = '#dcebf7';
      ctx.fillRect(0, 0, width, height);

      ctx.fillStyle = '#000';
      for (let i = 0; i < 120; i++) {
        ctx.fillRect(random(0, width), random(0, height), random(1, 2), random(1, 2));
      }

      ctx.font = 'bold 30px Georgia, "Times New Roman", serif';
      ctx.textBaseline = 'middle';
      const step = (width - 20) / code.length;
      code.split('').forEach((char, index) => {
        ctx.save();
        ctx.translate(12 + step * index + step / 2, height / 2 + random(-3, 3));
        ctx.rotate(random(-0.3, 0.3));
        ctx.fillText(char, -ctx.measureText(char).width / 2, 0);
        ctx.restore();
      });

      ctx.strokeStyle = '#000';
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(random(0, 15), random(5, height / 2));
      ctx.bezierCurveTo(
        random(width / 4, width / 2), random(0, height),
        random(width / 2, width * 0.75), random(0, height),
        random(width - 15, width), random(5, height / 2)
      );
      ctx.stroke();

      return canvas.toDataURL();
    },
    socialIdTypeChanged() {
      this.$set(this.formModel, `socialId${this.formattedSuggestedTechnicalName}`, null);
      this.resetPersonalInfo();
    },
    socialChanged() {
      this.$set(this.formModel, `dateOfBirth${this.formattedSuggestedTechnicalName}`, null);
      this.resetPersonalInfo();
    },
    dateOfBirthChanged() {
      if (this.isViewMode || !this.isRequiresChecking) {
        return;
      }

      if (this.firstBirthDateChangeOccurred) {
        this.resetPersonalInfo();
      }
    },
    resetPersonalInfo() {
      this.$set(this.formModel, `isRetrievedFromMoi${this.formattedSuggestedTechnicalName}`, false);
      this.$set(this.formModel, `isRetrievedFromMci${this.formattedSuggestedTechnicalName}`, false);
      this.$set(this.formModel, `isRetrievedFromPrisons${this.formattedSuggestedTechnicalName}`, false);
      this.$set(this.formModel, `firstName${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `fatherName${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `grandFatherName${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `familyName${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `passportDate${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `passportSource${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `isPrisoner${this.formattedSuggestedTechnicalName}`, false);
      this.$set(this.formModel, `prisonerNo${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `prisonName${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `prisonCityId${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `sex${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `lifeStatusId${this.formattedSuggestedTechnicalName}`, null);
      if (this.isSaudi) {
        this.$set(this.formModel, `nationalityCountryId${this.formattedSuggestedTechnicalName}`, countriesEnum.saudiArabia);
      } else {
        this.$set(this.formModel, `nationalityCountryId${this.formattedSuggestedTechnicalName}`, null);
      }
      this.$set(this.formModel, `nationalAddress${this.formattedSuggestedTechnicalName}`, {});
      this.$set(this.formModel, `nationalAddresses${this.formattedSuggestedTechnicalName}`, []);
      this.requestError = null;
    },
    needToTranslateChangeHandler() {
      this.$set(this.formModel, `languageId${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `subLanguageId${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `mainLanguageId${this.formattedSuggestedTechnicalName}`, null);
      this.subLanguages = [];
    },
    restoreLanguageSelections() {
      const savedLanguageId = this.formModel[`languageId${this.formattedSuggestedTechnicalName}`];
      if (!savedLanguageId) {
        this.subLanguages = [];
        return;
      }

      // call the API to get the language details
      this.getMainSubLanguageDetailsById(savedLanguageId)
        .then((result) => {
          const languageDetails = result?.data || result;

          if (!Array.isArray(languageDetails) || languageDetails.length === 0) {
            this.subLanguages = [];
            return;
          }

          const { mainLanguageId, subLanguageId } = languageDetails[0];

          // since mainLanguages is already loaded, just set the mainLanguageId
          this.$set(this.formModel, `mainLanguageId${this.formattedSuggestedTechnicalName}`, mainLanguageId);

          // load sub languages for the main language
          if (mainLanguageId) {
            return this.getSubLanguages(mainLanguageId)
              .then((subLanguagesResult) => {
                this.subLanguages = Array.isArray(subLanguagesResult) ? subLanguagesResult : (subLanguagesResult?.data || []);

                // return the subLanguageId so we can use it in the next then block
                return subLanguageId;
              });
          }
        })
        .then((subLanguageId) => {
          // set the sub language selection
          if (subLanguageId && this.subLanguages.length > 0) {
            const matchingSubLanguage = this.subLanguages.find(subLang =>
              subLang.subLanguageId === subLanguageId || subLang.id === savedLanguageId
            );
            if (matchingSubLanguage) {
              this.$set(this.formModel, `languageId${this.formattedSuggestedTechnicalName}`, matchingSubLanguage.id);
              this.$set(this.formModel, `subLanguageId${this.formattedSuggestedTechnicalName}`, subLanguageId);
            }
          }
        })
        .catch(() => {
          // fall back to normal flow
          this.subLanguages = [];
        });
    },
    mainLanguageChanged() {
      // reset sub-language selections when main language changes
      this.$set(this.formModel, `languageId${this.formattedSuggestedTechnicalName}`, null);
      this.$set(this.formModel, `subLanguageId${this.formattedSuggestedTechnicalName}`, null);
      this.subLanguages = [];
      const selectedMainLanguageId = this.formModel[`mainLanguageId${this.formattedSuggestedTechnicalName}`];
      if (selectedMainLanguageId) {
        this.getSubLanguages(selectedMainLanguageId)
          .then((result) => {
            this.subLanguages = Array.isArray(result) ? result : (result?.data || []);
          })
          .catch(() => {
            this.subLanguages = [];
          });
      } else {
        this.subLanguages = [];
      }
    },
    subLanguageChanged(selectedId) {
      if (!selectedId) {
        // clear all language-related fields if no item is selected
        this.$set(this.formModel, `languageId${this.formattedSuggestedTechnicalName}`, null);
        this.$set(this.formModel, `subLanguageId${this.formattedSuggestedTechnicalName}`, null);
        return;
      }
      // find the selected item from subLanguages array
      const selectedItem = this.subLanguages.find(item => item.id === selectedId);
      if (selectedItem) {
        // save the link table ID (what was originally being saved)
        this.$set(this.formModel, `languageId${this.formattedSuggestedTechnicalName}`, selectedItem.id);
        // save the actual SubLanguageId
        this.$set(this.formModel, `subLanguageId${this.formattedSuggestedTechnicalName}`, selectedItem.subLanguageId);
      }
    },
    setNationalityCountryName() {
      const country = (this.selectedCountries || []).find(a => a.id == this.formModel[`nationalityCountryId${this.formattedSuggestedTechnicalName}`]) || {};
      this.$set(this.formModel, `nationalityCountryName${this.formattedSuggestedTechnicalName}`, country.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.moi-error {
  display: inline-block;
  margin-bottom: 10px;
  &:not(.ivu-alert-with-icon) {
    padding-right: 16px;
    padding-left: 16px;
  }
}
.add-new-person ::v-deep {
  .checkbox-field {
    margin-bottom: 20px !important;
  }
}
.needs-translator-input {
  margin-bottom: 35px;
}
.verification-code-container {
  gap: 8px;
  > :first-child {
    flex: 1;
    min-width: 0;
  }
  .verification-code-box {
    margin-top: 26px;
    height: 50px;
    width: auto;
    flex-shrink: 0;
    box-sizing: border-box;
    border: 1px solid #b5b5b5;
    user-select: none;
  }
}
.check-container {
  display: flex;
  align-items: center;
  .v-button-wrapper {
    margin-left: 10px;
  }
}
</style>
